export const TRANSCON_DATE = new Date('2024-03-01T08:00:00.000-08:00');

export const FINISH_DATE = new Date('2024-04-21T18:54:29.000Z');

export const PAUL_STRAVA_ID = 107251059;
